import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getDatabase, ref, onValue, set, onDisconnect, serverTimestamp } from "firebase/database";
import alertify from "./alertify";
import { setFcmUserToken, removeFcmUserToken } from "@/services/notificationService";
import userNotificationService from "@/services/userNotificationService";
import router from "@/router";

// Firebase configuration
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL || `https://${import.meta.env.VITE_FIREBASE_PROJECT_ID}-default-rtdb.firebaseio.com`,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);
let messaging;
try {
  messaging = getMessaging(app);
} catch (error) {
  console.error("Firebase messaging error:", error);
}

// Request notification permission and get token
export const requestNotificationPermission = async () => {
  if (!messaging) {
    console.error("Firebase messaging not initialized");
    return null;
  }
  
   
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const token = await getToken(messaging);
      
      if (token) {
        console.log('FCM Token:', token);
        // Register token with your notification service
        await setFcmUserToken(token);
        return token;
      } else {
        console.warn('No FCM token received');
      }
    } else {
      console.log('Notification permission denied');
    }
  } catch (error) {
    console.error("Notification permission error:", error);
    if (error.code === 'messaging/invalid-vapid-key') {
      console.error('Invalid VAPID key. Please check your Firebase console for the correct key.');
    }
  }
  return null;
};

// Remove FCM token (call when user logs out)
export const removeNotificationToken = async () => {
  try {
    await removeFcmUserToken();
  } catch (error) {
    console.error("Error removing FCM token:", error);
  }
};

if (messaging) {
  onMessage(messaging, (payload) => {
    console.log("🚀 ~ onMessageListener ~ payload:", payload);
    try {
      const title = payload.notification.title;
      const data = payload.data;
      let message = payload.notification.body;
      const types = {
        0: "success",
        1: "success",
        2: "warning",
        3: "error",
        4: "error",
      };
      const type = types[data.NotificationSeverity] || "success"; // Default to success if severity is missing

      // Dispatch event to refresh notification lists
      window.dispatchEvent(new CustomEvent('firebase-notification-received', {
        detail: { payload, data }
      }));

      // Handle notifications
      const handleNotificationClick = () => {
        try {
          console.log('Foreground notification click data:', data);
          
          const target = userNotificationService.resolveNavigationTarget({
            data: {
              tableName: data.tableName,
              entityId: data.entityId,
              sourceReferenceId: data.sourceReferenceId,
              relatedEntityType: data.relatedEntityType,
              payload: data
            },
            relatedEntityType: data.relatedEntityType
          });

          if (target?.path) {
            console.log('Navigating from notification to:', target.path, target.query || {});
            router.push({
              path: target.path,
              query: target.query || {}
            });
          }
        } catch (error) {
          console.error("Error handling notification click:", error);
        }
      };

      alertify[type]({
        title,
        message,
        onClick: handleNotificationClick
      });
    } catch (error) {
      console.error("onMessageListener error:", error);
    }
  });
}

export { database, ref, onValue, set, onDisconnect, serverTimestamp };
export default messaging;
